import type { Currency, DataStatus } from "../types/domain";

export const formatCurrency = (value: number | null | undefined, currency: Currency) => {
  if (value === null || value === undefined || Number.isNaN(value)) return "Unavailable";
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: currency || "USD",
    maximumFractionDigits: value >= 100 ? 0 : 2
  }).format(value);
};

export const formatPercent = (value: number | null | undefined, digits = 1) => {
  if (value === null || value === undefined || Number.isNaN(value)) return "Unavailable";
  return `${(value * 100).toFixed(digits)}%`;
};

export const formatNumber = (value: number | null | undefined, digits = 1) => {
  if (value === null || value === undefined || Number.isNaN(value)) return "Unavailable";
  return new Intl.NumberFormat("en-US", { maximumFractionDigits: digits }).format(value);
};

export const statusLabel = (status: DataStatus) => {
  const labels: Record<DataStatus, string> = {
    approved: "Approved",
    pending: "Pending",
    sample: "Sample data",
    stale: "Stale",
    unavailable: "Unavailable"
  };
  return labels[status];
};
